import { ActionBarRight, ActionBarWrapper } from '@components/UI/Card/Card.styled'
import { ISubmission } from '@store/submissions'
import ActionBarIconChat from '../Icon/Chat'

interface IProps {
  campaignId: number
  submission: ISubmission
  hasFeedbackLink: boolean
}

const SubmissionCardActionBarContentDeclined: React.FC<IProps> = ({
  campaignId,
  submission,
  hasFeedbackLink,
}) => {
  return (
    <ActionBarWrapper justifyEnd>
      <ActionBarRight>
        {hasFeedbackLink && <ActionBarIconChat submission={submission} campaignId={campaignId} />}
      </ActionBarRight>
    </ActionBarWrapper>
  )
}

export default SubmissionCardActionBarContentDeclined
